import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UserDataType } from "@winshop-crm/types";

type UserState = UserDataType | null;

const initialState = null as UserState;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (_state, action: PayloadAction<UserDataType>) => action.payload,
  },
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;
